import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import localizedFormat from 'dayjs/plugin/localizedFormat'

// Add required plugins
dayjs.extend(utc)
dayjs.extend(localizedFormat)

export function formatEventTimeRange(bookedEventInfo) {
  if (!bookedEventInfo?.startTime || !bookedEventInfo?.endTime) {
    return 'Time not available'
  }

  // Parse UTC times and convert to local timezone
  const startTime = dayjs.utc(bookedEventInfo.startTime).local()
  const endTime = dayjs.utc(bookedEventInfo.endTime).local()

  // Calculate duration in minutes
  const durationMins = endTime.diff(startTime, 'minute')

  // Format the date and time parts
  const startDate = startTime.format('Do MMMM')
  const startTimeStr = startTime.format('h:mmA')
  const endTimeStr = endTime.format('h:mmA')

  // Check if start and end dates are the same
  const isSameDay = startTime.isSame(endTime, 'day')

  // Create the formatted string
  let timeRangeStr
  if (isSameDay) {
    timeRangeStr = `${startDate}: ${startTimeStr} - ${endTimeStr} (${durationMins} mins)`
  } else {
    const endDate = endTime.format('Do MMMM')
    timeRangeStr = `${startDate}: ${startTimeStr} - ${endDate}: ${endTimeStr} (${durationMins} mins)`
  }

  return timeRangeStr
}

export function formatRescheduleTimeChange(bookedEventInfo, rescheduleStartTime) {
  if (!bookedEventInfo?.startTime || !rescheduleStartTime) {
    return 'Reschedule information not available'
  }

  // Parse original times (in UTC) and convert to local timezone
  const originalStartTime = dayjs.utc(bookedEventInfo.startTime).local()
  const originalEndTime = dayjs.utc(bookedEventInfo.endTime).local()

  // Calculate original duration in minutes
  const originalDurationMins = originalEndTime.diff(originalStartTime, 'minute')

  // Parse new start time (in UTC) and convert to local timezone
  const newStartTime = dayjs.utc(rescheduleStartTime).local()

  // Calculate new end time based on original duration
  const newEndTime = newStartTime.add(originalDurationMins, 'minute')

  // Format the date and time parts for original time
  const originalStartDate = originalStartTime.format('Do MMMM')
  const originalStartTimeStr = originalStartTime.format('h:mmA')

  // Format the date and time parts for new time
  const newStartDate = newStartTime.format('Do MMMM')
  const newStartTimeStr = newStartTime.format('h:mmA')
  const newEndTimeStr = newEndTime.format('h:mmA')

  // Check if the reschedule is on the same day as the original
  const isSameDay = originalStartTime.isSame(newStartTime, 'day')
  const isNewStartEndSameDay = newStartTime.isSame(newEndTime, 'day')

  // Create the formatted string
  let rescheduleTimeStr

  // From part: Original appointment time
  const fromPart = `${originalStartDate} ${originalStartTimeStr}`

  // To part: New appointment time
  let toPart
  if (isNewStartEndSameDay) {
    toPart = `${newStartDate} ${newStartTimeStr}`
  } else {
    toPart = `${newStartDate} ${newStartTimeStr}`
  }

  // Put it all together
  rescheduleTimeStr = `from ${fromPart} TO ${toPart} (${originalDurationMins} mins)`

  // // Add a simple indication if the day has changed
  // if (!isSameDay) {
  //   rescheduleTimeStr += `\n(Date changed from ${originalStartDate} to ${newStartDate})`
  // }

  return rescheduleTimeStr
}
